module.exports = require('next/error')



//////////////////
// WEBPACK FOOTER
// ./node_modules/next/dist/pages/_error.js
// module id = ./node_modules/next/dist/pages/_error.js
// module chunks = 0